export default __webpack_public_path__ + "static/screenshots-generator-1-0d65adb9172848af233db69ca27410f7.png";